export const ISSUE_REFRESH_INTERVAL_MS = 10000;
